import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "fix-width-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none" },
        React.createElement("path", { d: "M0 0h17v17H0z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M13 8.5H4" }),
        React.createElement("rect", { width: 1, height: 4, x: 3, y: 6.5, fill: "currentColor", fillRule: "evenodd", rx: 0.5 }),
        React.createElement("rect", { width: 1, height: 4, x: 13, y: 6.5, fill: "currentColor", fillRule: "evenodd", rx: 0.5 })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
